/**
 * Automy.Core.Enums.Reporting.Queries.ReportingQueryOrderDirection
 * Native queries[].orderBy[].direction (string token).
 */
export default Object.freeze({
  Ascending: 'asc',
  Descending: 'desc',
});
